import { Modal, Button } from "react-bootstrap";

const Thanks = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="custom-modal-radius"
    >
      <Modal.Body className="text-center p-4">
        <div>
          <div className="mb-3">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
          <h4 className="mb-2 fw-bold">Thank You!</h4>
          <h6 className="fw-bold mb-2">
            Your Telehealth Appointment Request has been submitted successfully!
          </h6>
          <p className="text-secondary mb-1" style={{ fontSize: "15px" }}>
            Our team will be reaching out to you shortly
          </p>
          <Button
            variant="primary"
            onClick={onClose}
            className="px-4 rounded-pill"
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Thanks;
